export const POLL_INTERVAL_MS = 10000
export const MAX_STABLE_POLLS = 3
